<div class="full-content">
  <div class="feature-wrapper modify">
    <div class="page-title">{{'mkb.card3dsecure.page.title' | resolve}}</div>
    <mat-card class="modify-content">
      <mat-card-content>
        <div class="modify-form">
          <form [formGroup]="modifyFormGroup">
            <div class="two-field-row">
              <mat-form-field class="w-200 pass-icon">
                <div class="filed-title">{{'mkb.card3dsecure.page.modify.secure.code.title' | resolve}}</div>
                <pass-visibilty-icon matSuffix #toggle></pass-visibilty-icon>
                <input matInput #password
                       [type]="toggle.type"
                       formControlName="secureCode">
              </mat-form-field>
              <a class="modify-code-link"
                 sessionReviveClick
                 (click)="modifyCode()">
                {{'mkb.card3dsecure.page.modify.secure.code.modify.button.title' | resolve}}
              </a>
            </div>
            <div class="infobox">
              {{'mkb.card3dsecure.page.modify.secure.code.info' | resolve}}
            </div>

            <div class="two-field-row">
              <mat-form-field class="w-200">
                <div class="filed-title">{{'mkb.card3dsecure.page.modify.status.title' | resolve}}</div>
                <input
                  style="display: none"
                  matInput
                  [readonly]="true"
                  formControlName="status">
                <div class="status-field">
                  {{'mkb.card3dsecure.page.modify.status.' + modifyFormGroup?.get('status').value | resolve}}
                </div>
                <mat-error *ngIf="modifyFormGroup?.get('status').hasError('banned')" class="multiline-error">
                  {{'mkb.card3dsecure.page.modify.status.banned.error' | resolve}}
                </mat-error>
                <mat-error *ngIf="modifyFormGroup?.get('status').hasError('blocked')" class="multiline-error">
                  {{'mkb.card3dsecure.page.modify.status.blocked.error' | resolve}}
                </mat-error>
              </mat-form-field>
              <a
                *ngIf="canBeActivated()"
                sessionReviveClick
                class="modify-code-link"
                (click)="activate()">
                {{'mkb.card3dsecure.page.modify.status.activate.button.title' | resolve}}
              </a>
            </div>

          </form>
        </div>
      </mat-card-content>
      <div class="card-pic">
        <div class="card-pic-wrapper">
          <div class="card">
            <img class="logo" src="assets/logo.svg" />
            <div class="card-number">{{cardLastNumbers | formatCard}}</div>
            <div class="card-owner-title">{{'mkb.card3dsecure.page.modify.mincard.owner.title' | resolve}}</div>
            <div class="card-owner">{{ownerName}}</div>
          </div>
        </div>
      </div>
    </mat-card>
    <a class="logout-link" (click)="logout()">{{'mkb.card3dsecure.page.modify.logout.button.title' | resolve}}</a>
  </div>
  <div class="side-bar-wrapper">
    <side-bar></side-bar>
  </div>
</div>
